<template>
  <el-dialog
    width="750px"
    body-class="dialog_body"
    :show-close="false"
    :visible.sync="dialogVisible"
  >
    <!-- 对话框头部-->
    <div slot="title" class="dialog_header">
      <span>车辆监控预警设置</span>
      <i class="el-icon-close" style="font-size: 26px" @click="close" />
    </div>

    <!-- 对话框头部 -->
    <div v-loading="loading">
      <!-- 对话框内容-->
      <el-card shadow="hover">
        <el-form
          ref="formRef"
          label-width="120px"
          label-position="left"
          style="max-width: 600px"
          :model="taskConfig"
          :rules="rules"
        >
          <el-form-item label="报警类型" prop="alarmType">
            <el-select
              v-model="taskConfig.alarmType"
              placeholder="请选择报警类型"
              multiple
              style="width: 100%"
              :clearable="true"
            >
              <el-option
                v-for="item in ALARM_TYPE"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="报警处理时效" prop="alarmCycle">
            <el-input-number
              v-model="taskConfig.alarmCycle"
              style="width: 50%"
              :precision="1"
              :controls="false"
            />&nbsp;&nbsp;小时
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="taskConfig.remark"
              placeholder="请输入备注"
              type="textarea"
            />
          </el-form-item>
        </el-form>
      </el-card>

      <!--操作按钮-->
      <div style="margin-top: 10px">
        <el-button
          type="primary"
          icon="el-icon-plus"
          :loading="addLoading"
          @click="addConfig(0)"
        >
          新增监控预警提醒
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-plus"
          :loading="addLoading"
          @click="addConfig(1)"
        >
          新增超时提醒
        </el-button>
      </div>

      <!-- 任务配置列表-->
      <template v-for="item in messageConfigs">
        <el-card
          shadow="hover"
          style="margin-top: 10px"
          :key="item.messageConfigId"
        >
          <template #header>
            <div style="display: flex; justify-content: space-between">
              <div style="line-height: 32px">
                {{ item.type === 1 ? "超时提醒" : "预警提醒" }}
              </div>
              <div>
                <el-button type="text" link @click="deleteConfig(item)">
                  删除
                </el-button>
              </div>
            </div>
          </template>

          <el-form
            label-width="100px"
            label-position="left"
            style="max-width: 600px"
          >
            <el-form-item label="状态" required="true">
              <el-switch v-model="item.enable" />
            </el-form-item>
            <el-form-item label="条件" required="true">
              {{
                item.type === 1
                  ? "当通知发出时间大于处理时效"
                  : "当通知发出时间小于处理时效"
              }}
              <el-input-number
                v-model="item.progressRate"
                :precision="1"
                :controls="false"
              />&nbsp;&nbsp;小时
            </el-form-item>
            <el-form-item
              v-if="item.type === 1"
              label="消息接收人"
              required="true"
            >
              <el-select
                v-model="item.roleIds"
                style="width: 100%"
                placeholder="请选择角色"
                multiple="true"
                clearable
                filterable
              >
                <el-option
                  v-for="role in roleInfos"
                  :key="role.roleId"
                  :value="role.roleId"
                  :label="role.roleName"
                />
              </el-select>
              <el-select
                v-model="item.userIds"
                style="margin-top: 10px; width: 100%"
                placeholder="请选择人员"
                multiple="true"
                clearable
                filterable
              >
                <el-option
                  v-for="user in userInfos"
                  :key="user.id"
                  :value="user.id"
                  :label="user.nickName + '(' + user.username + ')'"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="消息内容" required="true">
              <el-input
                v-model="item.messageContent"
                placeholder="请输入备注"
                type="textarea"
                autosize
                :maxlength="200"
              />
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model="item.remark"
                placeholder="请输入备注"
                type="textarea"
                autosize
                :maxlength="200"
              />
            </el-form-item>
          </el-form>
        </el-card>
      </template>
    </div>

    <!--底部提交按钮-->
    <template slot="footer">
      <el-button type="primary" @click="save">确定</el-button>
      <el-button @click="close">取消</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { userQueryPage } from "@/api/system/user";
import { roleQueryAll } from "@/api/system/role";
import {
  reminderSaveOrUpdate,
  reminderDetail,
} from "@/api/system/reminderConfig";
import {
  ALARM_TYPE,
  ALARM_TEMPLATE_0,
  ALARM_TEMPLATE_1,
} from "@/pages/system/reminder/config";
import { SYSTEM_SETTING, checkPermission } from "@/permission";

export default {
  name: "reminder-setting",
  data() {
    return {
      ALARM_TYPE,
      ALARM_TEMPLATE_0,
      ALARM_TEMPLATE_1,
      dialogVisible: false,
      disabled: !checkPermission([SYSTEM_SETTING.REMINDER_SETTING.EDIT]),
      loading: false,
      saveLoading: false,
      addLoading: false,
      roleInfos: [],
      userInfos: [],
      taskConfig: {
        configId: undefined,
        alarmType: [],
        alarmCycle: 1,
        remark: undefined,
      },
      messageConfigs: [],
      rules: {
        alarmType: [
          { required: true, message: "请选择报警类型", trigger: "change" },
        ],
        alarmCycle: [
          { required: true, message: "请输入报警处理时效", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    openAdd() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
      this.taskConfig = {
        configId: undefined,
        alarmType: [],
        alarmCycle: undefined,
        remark: undefined,
      };
      this.messageConfigs = [];
      const params = {
        pageNum: 1,
        pageSize: 99999,
      };
      userQueryPage(params).then((res) => {
        if (res.code == 0) {
          this.userInfos = res.result.list;
        }
      });
      roleQueryAll().then((res) => {
        if (res.code == 0) {
          this.roleInfos = res.result;
        }
      });
    },
    async openDetail(row) {
      this.dialogVisible = true;
      this.loading = true;
      this.taskConfig = {
        configId: undefined,
        alarmType: [],
        alarmCycle: undefined,
        remark: undefined,
      };
      this.messageConfigs = [];
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
      const params = {
        pageNum: 1,
        pageSize: 99999,
      };
      await userQueryPage(params).then((res) => {
        if (res.code == 0) {
          this.userInfos = res.result.list;
        }
      });
      await roleQueryAll().then((res) => {
        if (res.code == 0) {
          this.roleInfos = res.result;
        }
      });
      reminderDetail(row.configId)
        .then((res) => {
          if (res.code == 0) {
            this.taskConfig = res.result;
            this.messageConfigs = res.result.messageConfig;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      this.saveLoading = true;
      if (this.validateBeforeSave()) {
        this.saveLoading = false;
        return;
      }
      const user = JSON.parse(localStorage.getItem("admin.user"));
      const params = {
        configId: this.taskConfig.configId || null,
        alarmCycle: this.taskConfig.alarmCycle,
        alarmType: this.taskConfig.alarmType,
        remark: this.taskConfig.remark,
        messageConfig: this.messageConfigs || [],
        operatorId: user ? user.id : null,
      };
      reminderSaveOrUpdate(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
            this.close();
            this.$emit("submit");
          }
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    validateBeforeSave() {
      if (
        !this.taskConfig.alarmType ||
        this.taskConfig.alarmType.length === 0
      ) {
        this.$message.warning("请选择报警类型!");
        return true;
      }
      if (isNaN(this.taskConfig.alarmCycle)) {
        this.$message.warning("请正确填写报警处理时效!");
        return true;
      }
      if (this.messageConfigs?.length > 0) {
        for (const messageConfig of this.messageConfigs) {
          if (
            isNaN(messageConfig.progressRate) ||
            messageConfig.progressRate <= 0
          ) {
            this.$message.warning("您有消息配置没有填写条件!");
            return true;
          }
          if (
            messageConfig.type === 0 &&
            messageConfig.progressRate >= this.taskConfig.alarmCycle
          ) {
            this.$message.warning("预警配置条件需要小于报警处理时效!");
            return true;
          }
          if (
            messageConfig.type === 1 &&
            messageConfig.userIds.length === 0 &&
            messageConfig.roleIds.length === 0
          ) {
            this.$message.warning("您有消息配置没有选择消息接收人");
            return true;
          }
          if (!messageConfig.messageContent) {
            this.$message.warning("您有消息配置没有填写消息内容!");
            return true;
          }
        }
      }
      return false;
    },
    addConfig(type) {
      if (type === 0) {
        const flag =
          this.messageConfigs.filter((item) => {
            return item.type === 0;
          }).length > 0;
        if (flag) {
          this.$message.warning("预警设置只能配置一个!");
          return true;
        }
      }
      if (type === 1) {
        const flag =
          this.messageConfigs.filter((item) => {
            return item.type === 1;
          }).length > 0;
        if (flag) {
          this.$message.warning("超期设置只能配置一个!");
          return true;
        }
      }
      this.addLoading = true;
      this.messageConfigs.unshift({
        messageConfigId: this.getUuid(),
        progressRate: undefined,
        enable: true,
        type: type,
        messageContent:
          type === 0 ? this.ALARM_TEMPLATE_0 : this.ALARM_TEMPLATE_1,
        userIds: [],
        roleIds: [],
      });
      this.addLoading = false;
    },
    deleteConfig(item) {
      this.messageConfigs = this.messageConfigs.filter((config) => {
        return config.messageConfigId !== item.messageConfigId;
      });
    },
    getUuid() {
      let timestamp = new Date().getTime();
      let perforNow =
        (typeof performance !== "undefined" &&
          performance.now &&
          performance.now() * 1000) ||
        0;
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        let random = Math.random() * 16;
        if (timestamp > 0) {
          random = (timestamp + random) % 16 | 0;
          timestamp = Math.floor(timestamp / 16);
        } else {
          random = (perforNow + random) % 16 | 0;
          perforNow = Math.floor(perforNow / 16);
        }
        return (c === "x" ? random : (random & 0x3) | 0x8).toString(16);
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    close() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog__header {
  background: rgb(26, 36, 62);
  display: flex;
  padding: 15px 20px;
}

::v-deep .el-dialog__body {
  padding: 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

::v-deep .el-card__header {
  padding: 10px 20px;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}

.dialog_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  color: #fff;
}
.dialog_body {
  height: "650px";
  overflow-y: "auto";
}
</style>

